import React, { Component } from 'react'
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { instagramOauthActions } from "_actions";
import { Loading } from "components/common";
import { styles } from "components/OauthComponents";
import {alertActions} from "_actions";
import {alertMessages} from "_constants";
import {PagesForm} from "./Pages";


class InstagramPages extends Component {

    constructor(props) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
    }

    onSubmit(pages) {
        /**
         * data comes in the format {page_pageId:true,page_pageId:false}
         */
        const pageSelected = Object.keys(pages).some(key => {
            return pages[key]
        });

        if (pageSelected){
            this.props.dispatch(instagramOauthActions.submitSelectedPage(pages))
        } else {
            this.props.dispatch(alertActions.error(alertMessages.PAGES_LENGTH_ERROR))
        }

    }

    componentDidMount() {
        this.props.dispatch(instagramOauthActions.getPages())
    }

    render() {

        const {handleSubmit, pages, loading} = this.props;
        const {buttonHolder} = styles;

        if (loading) {
            return <Loading/>
        }

        if (pages && pages.length === 0){
            return (
                <div className="main-content-wrapper">
                    <div className="content-pane-60 margin-0-auto">
                        <div className="padding-20-0">
                            <div>
                                It looks like your account does not have administrator access for any
                                [Facebook / Instagram] pages.
                                Please login with another account
                            </div>
                            <a href="/company/connectchannels">
                                <button className="btn btn-success btn-small">
                                    Login with another account
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <PagesForm
                    pageType="Instagram Page"
                    pages={pages}
                    handleSubmit={handleSubmit(this.onSubmit)}
                    buttonHolder={buttonHolder}
                    pageTitle="Choose Instagram Pages"
                />
            );
        }
    }
}

function mapStateToProps(state) {

    return {
        pages:state.instagramOauth.data,
        loading: state.instagramOauth.loading
    }
}

const formConfig = {
    form: 'instagramPagesForm'
};

InstagramPages = connect(
    mapStateToProps,
    null
)(InstagramPages);

const connectedinstagramPages = reduxForm(formConfig)(InstagramPages);

export { connectedinstagramPages as InstagramPages }